'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPersistedThread = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPersistedThread = exports.isPersistedThread = (0, _pipe2.default)(_threadGetters.getChannel, function (channel) {
  switch (channel) {
    case _stubbedChannel.STUBBED_CHANNEL:
      return false;
    default:
      return true;
  }
});


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/operators/isPersistedThread.js
// module id = 57
// module chunks = 2 3